/* eslint-disable object-property-newline */
/* eslint-disable no-lonely-if */
import gsap from 'gsap';
import * as scenesDataJson from '../data/scenes-data.json';
import Utils from '../utils';

const gameManagerComponent = {

  init() {
    window.gameManager = this;

    this.currentSkyTextureId = 0;
    this.isChangingScene = false;
    this.skyTextures = [
      '#sky-texture1',
      '#sky-texture2',
      '#sky-texture3',
      '#sky-texture4',
      '#sky-texture5',
      '#sky-texture6',
      '#sky-texture7',
      '#sky-texture8',
      '#sky-texture9',
      '#sky-texture10',
      '#sky-texture11',
    ];
    this.arScenesParent = this.el.sceneEl.querySelector('#arScenes');
  },

  customInit() {
    this.debug = Utils.paramIsEnabled('debug');

    this.aCamera = this.el.sceneEl.querySelector('#camera')
    if (this.debug) {
      this.aCamera.components['wasd-controls'].data.enabled = true;
    }

    this.reflectionComponent = this.el.sceneEl.components.reflection;

    // const box1 = document.querySelector('#box1');
    // console.log('box1:', box1);

    this.sky = document.querySelector('#sky');

    const previousSkyBtn = document.querySelector('#previousSkyBtn');
    previousSkyBtn.onclick = () => {
      this.previousSkyPressed();
    };

    const nextSkyBtn = document.querySelector('#nextSkyBtn');
    nextSkyBtn.onclick = () => {
      this.nextSkyPressed();
    };

    this.subscribeToEvents();

    setTimeout(() => {
      const firstScene = 'scene_1';
      this.changeScene(firstScene);
    }, 100);

    if (Utils.paramIsEnabled('debug')) {
      document.addEventListener('keydown', (event) => { // DEV DEBUG TEST
        // console.log('document.addEventListener - event:', event);
        if (event.key === 't') {
          this.el.sceneEl.emit('showMessage', {
            title: 'Title',
            message: ['First test message.', 'Second test message.'],
          }, false);
        }
      });
    }
  },

  subscribeToEvents() {
    this.el.sceneEl.addEventListener('changeScene', (event) => {
      this.changeScene(event.detail.newScene);
    });
  },

  startGame() {
    setTimeout(() => {
      window.audioManager.playSoundElement('#welcomeSound');
      window.uiManager.showIntroMessage(() => {
        window.audioManager.stopSoundElement('#welcomeSound');
        this.setRaycastEnabled(true);
      });
    }, 1900);
  },

  setRaycastEnabled(newStatus = true) {
    interactionCursor.components.raycaster.data.enabled = newStatus;
  },

  changeScene(newScene) {
    // console.log('changeScene() - newScene:', newScene);
    // Hide first
    this.isChangingScene = true;
    // this.sky.emit('fadeout');
    window.uiManager.showHideBlackScreen(true);
    setTimeout(() => {
      this.changeSky(newScene);
      this.showArSceneParent(newScene);
      // this.sky.emit('fadein');
      setTimeout(() => {
        window.uiManager.showHideBlackScreen(false);
        this.isChangingScene = false;
      }, 300);
    }, 500);
  },

  showArSceneParent(newScene) {
    // console.log('showArSceneParent() - newScene:', newScene, ', scenesDataJson:', scenesDataJson);
    // Hide all scene parents:
    for (let i = 0; i < this.arScenesParent.children.length; i++) {
      this.arScenesParent.children[i].setAttribute('visible', false);
      // console.log('showArSceneParent - this.arScenesParent.children[i]:', this.arScenesParent.children[i]);
    }
    // Show new scene parent:
    const selector = scenesDataJson.scenes[newScene].htmlParentSelector;
    const parent = this.el.sceneEl.querySelector(selector);
    // console.log('showArSceneParent() - selector:', selector, ', parent:', parent);
    parent.setAttribute('visible', true);
    parent.object3D.rotation.y = (scenesDataJson.scenes[newScene].envMapRotationX || 0) * (Math.PI / 180);

    /*const raycastInteractableObjectsToEnable = Array.from(parent.querySelectorAll('.raycastInteractable'));
    console.log('showArSceneParent - raycastInteractableObjectsToEnable:', raycastInteractableObjectsToEnable);
    const raycastInteractableObjectsToDisable = Array.from(this.arScenesParent.querySelectorAll('.raycastInteractable'));
    for (let k = 0; k < raycastInteractableObjectsToEnable.length; k++) {
      if (raycastInteractableObjectsToEnable[k].wasInteractive) {
        raycastInteractableObjectsToEnable[k].classList.add('raycastInteractable');
        console.log('showArSceneParent() - Enable:', raycastInteractableObjectsToEnable[k]);
        raycastInteractableObjectsToEnable[k].wasInteractive = null;
      }
    }
    for (let j = 0; j < raycastInteractableObjectsToDisable.length; j++) {
      if (
        raycastInteractableObjectsToDisable[j].classList.contains('raycastInteractable') &&
        !raycastInteractableObjectsToEnable.includes(raycastInteractableObjectsToDisable[j])
      ) {
        raycastInteractableObjectsToDisable[j].classList.remove('raycastInteractable');
        console.log('showArSceneParent() - Disable:', raycastInteractableObjectsToDisable[j]);
        raycastInteractableObjectsToDisable[j].wasInteractive = true;
      }
    }*/
    this.el.sceneEl.emit('sceneChanged', { newScene: newScene }, false);
  },

  previousSkyPressed() {
    if (this.currentSkyTextureId - 1 >= 0 && !this.isChangingScene) {
      this.currentSkyTextureId -= 1;
      const newSkyTexture = this.skyTextures[this.currentSkyTextureId];
      this.changeSky(newSkyTexture);
    }
  },

  nextSkyPressed() {
    if (this.skyTextures.length > this.currentSkyTextureId + 1 && !this.isChangingScene) {
      this.currentSkyTextureId += 1;
      const newSkyTexture = this.skyTextures[this.currentSkyTextureId];
      this.changeSky(newSkyTexture);
    }
  },

  changeSky(newScene) {
    if (this.sky) {
      // console.log('changeSky() - newScene:', newScene, ', scenesDataJson.scenes[newScene].envMap:', scenesDataJson.scenes[newScene].envMap);
      this.sky.setAttribute('src', scenesDataJson.scenes[newScene].envMap);
      this.sky.components.material.material;
      this.sky.object3D.rotation.y = (scenesDataJson.scenes[newScene].envMapRotationX || 0) * (Math.PI / 180);
      // console.log('changeSky() - sky material:', this.sky.components.material.material);
      // const depthTexture = document.querySelector('#sky-texture1-depth');
      // console.log('setTimeout - depthTexture:', depthTexture);
      if (this.reflectionComponent) {
        this.reflectionComponent.needsVREnvironmentUpdate = true;
      }
    }
  }
};

export default gameManagerComponent;
